import {
  HTTP_CHECKGETTOKEN_FETCHING,
  HTTP_CHECKGETTOKEN_SUCCESS,
  HTTP_CHECKGETTOKEN_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_CHECKGETTOKEN_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_CHECKGETTOKEN_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_CHECKGETTOKEN_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
